import React, { Component } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
	clearEmptyPdfItems
} from '../../../actions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
	button: {
		margin: theme.spacing.unit,
		display:'inline-block',
		color:"#FFFFFF"
	},
	closeIcon:{
		position:'absolute',
		top:10,
		right:10
	},
});

class pdfViewer extends Component {
	
	handleClose = () => {
		this.props.dispatch(clearEmptyPdfItems());
	};
	
	
	render() {
		const {classes,filePath} = this.props;
		const height = (this.props.navigation.windowHeight * 0.95);
		const width = (this.props.navigation.windowWidth * 0.9) - 60;
		
		return (
			
			<div className="over_rays">
				<div className={classes.closeIcon}>
					<IconButton color={"primary"} className={classes.button} aria-label="CLOSE"
								onClick={this.handleClose}>
						<CloseIcon/>
					</IconButton>
				</div>
				
				<div className="pdf_inner">
					<embed
						src={filePath}
						width={width}
						height={height}
					/>
				</div>
			</div>
		);
	}
}
pdfViewer.propTypes = {
	filePath:PropTypes.string
};
pdfViewer.defaultProps = {
	filePath:''
};
function mapStateToProps(state) {
	return {
		navigation : state.navigation
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(pdfViewer);


// WEBPACK FOOTER //
// ./src/common/components/viewer/brank-pdf-viewer.js